function capitalize(str) {
  return str.split(' ').map(char => {
    return char.charAt(0).toUpperCase() + char.slice(1).toLowerCase()
  }).join(' ');
}
export const generateMeta = ({data, specialLandingUrlSuffix}) => {
  let title = '';
  let metaTags = '';
  let metaKeyWords = '';

  // Default values — /auctions routes
  if (data.city) {
    title = `${capitalize(data.city)} Home Auctions | Bid on Properties in ${capitalize(data.city)} | Hubzu`;
    metaTags = `Search ${capitalize(data.city)} home auctions on Hubzu. View photos, review property details, and participate in online bidding.`;
    metaKeyWords = `${capitalize(data.city)} home auctions, ${capitalize(data.city)} real estate auctions, homes for auction ${capitalize(data.city)}`;
  } else if (data.state) {
    title = `${capitalize(data.stateName)} Home Auctions | Browse Properties Across ${data.state.toUpperCase()} | Hubzu`;
    metaTags = `Explore homes available through auctions in ${capitalize(data.stateName)}. View property details and participate in online bidding on Hubzu.`;
    metaKeyWords = `${capitalize(data.stateName)} home auctions, homes for auction in ${capitalize(data.stateName)}, ${data.state.toUpperCase()} real estate auctions`;
  } else {
    title = 'Homes for Auction | Browse Properties Nationwide | Hubzu';
    metaTags = 'Discover homes available through online auctions across the U.S. on Hubzu. Review property details and place bids in a transparent environment.';
    metaKeyWords = 'homes for auction, real estate auctions, online home auctions';
  }

  // Handle special landing URL suffixes
  if (specialLandingUrlSuffix) {
    if (specialLandingUrlSuffix.includes('/foreclosures-near-me')) {
      title = 'Foreclosure Homes Near Me | Local Auction Opportunities | Hubzu';
      metaTags = 'Search foreclosure homes available through auction in your area. View property details and participate in online bidding.';
      metaKeyWords = 'foreclosure homes near me, foreclosure auctions nearby, foreclosed homes for auction';
    } else if (specialLandingUrlSuffix.includes('/short-sale-properties-near-me')) {
      title = 'Short Sale Homes Near Me | Local Auction Opportunities | Hubzu';
      metaTags = 'Browse short sale homes available near you. View details, photos, and participate in online auctions.';
      metaKeyWords = 'short sale homes near me, short sale auction homes, local short sales';
    } else if (specialLandingUrlSuffix.includes('/short-sale-near-me')) {
      title = 'Short Sale Properties | Auction Opportunities | Hubzu';
      metaTags = 'Explore short sale properties available through auction. Review property details and participate in bidding.';
      metaKeyWords = 'short sale properties, short sale homes for sale, distressed short sales';
    } else if (specialLandingUrlSuffix.includes('/bank-owned-properties-near-me')) {
      title = 'Bank-Owned Homes Near Me | REO Auction Properties | Hubzu';
      metaTags = 'Explore bank-owned homes available near you. View property details and participate in online auctions.';
      metaKeyWords = 'bank owned homes near me, REO homes near me, bank owned property auctions';
    } else if (specialLandingUrlSuffix.includes('/bank-owned-near-me')) {
      title = 'REO Properties | Bank-Owned Homes for Auction | Hubzu';
      metaTags = 'Browse REO properties available through auction. View details and participate in online bidding.';
      metaKeyWords = 'REO properties, bank-owned homes, REO homes for auction';
    } else if (specialLandingUrlSuffix.includes('/auctions-near-me')) {
      title = 'Homes for Auction Near Me | Local Properties | Hubzu';
      metaTags = 'Discover homes available through auction near you. View property details and place bids on Hubzu.';
      metaKeyWords = 'homes for auction near me, local home auctions, houses for auction nearby';
    } else if (specialLandingUrlSuffix.includes('/real-estate-auctions-near-me')) {
      title = 'Real Estate Auctions Near Me | Find Local Properties | Hubzu';
      metaTags = 'Search real estate auctions near you. Browse properties and participate in online bidding.';
      metaKeyWords = 'real estate auctions near me, property auctions near me, auction homes nearby';
    } else if (specialLandingUrlSuffix.includes('/near-me')) {
      title = 'Homes Near Me | Browse Local Properties | Hubzu';
      metaTags = 'Find homes available near you. Explore property details and discover opportunities on Hubzu.';
      metaKeyWords = 'homes for sale near me, local homes for sale, properties near me';
    } else if (specialLandingUrlSuffix.includes('/commercial')) {
      if (data.city) {
        title = `${capitalize(data.city)} Commercial Properties | Auction Opportunities | Hubzu`;
        metaTags = `Explore commercial properties in ${capitalize(data.city)}. Review details and participate in bidding.`;
        metaKeyWords = `${capitalize(data.city)} commercial properties, commercial property in ${capitalize(data.city)}, ${capitalize(data.city)} foreclosure properties`;
      } else if (data.state) {
        title = `${capitalize(data.stateName)} Commercial Properties | Auction Opportunities | Hubzu`;
        metaTags = `Browse commercial properties in ${capitalize(data.stateName)}. View details and participate in online auctions.`;
        metaKeyWords = `${capitalize(data.stateName)} commercial properties, commercial property in ${capitalize(data.stateName)}, ${data.state.toUpperCase()} foreclosure properties`;
      } else {
        title = 'Commercial Properties | Browse Auction Opportunities | Hubzu';
        metaTags = 'Explore commercial properties available through auction. Review property details and participate in bidding.';
        metaKeyWords = 'commercial properties, commercial properties for sale, commercial buildings';
      }
    }  else if (specialLandingUrlSuffix.includes('/foreclosures')) {
      if (data.city) {
        title = `${capitalize(data.city)} Foreclosure Homes | Auction Opportunities | Hubzu`;
        metaTags = `Explore foreclosure homes in ${capitalize(data.city)}. Review details and participate in bidding.`;
        metaKeyWords = `${capitalize(data.city)} foreclosure homes, foreclosures in ${capitalize(data.city)}, ${capitalize(data.city)} foreclosure properties`;
      } else if (data.state) {
        title = `${capitalize(data.stateName)} Foreclosure Homes | Auction Opportunities | Hubzu`;
        metaTags = `Browse foreclosure homes in ${capitalize(data.stateName)}. View details and participate in online auctions.`;
        metaKeyWords = `${capitalize(data.stateName)} foreclosure homes, foreclosures in ${capitalize(data.stateName)}, ${data.state.toUpperCase()} foreclosure properties`;
      } else {
        title = 'Foreclosure Homes | Browse Auction Opportunities | Hubzu';
        metaTags = 'Explore foreclosure homes available through auction. Review property details and participate in bidding.';
        metaKeyWords = 'foreclosure homes, foreclosed homes for sale, foreclosure properties';
      }
    } else if (specialLandingUrlSuffix.includes('/short-sale')) {
      if (data.city) {
        title = `${capitalize(data.city)} Short Sale Homes | Auction Opportunities | Hubzu`;
        metaTags = `Explore short sale homes in ${capitalize(data.city)}. Review details and participate in bidding.`;
        metaKeyWords = `${capitalize(data.city)} short sale homes, short sale homes in ${capitalize(data.city)}, ${capitalize(data.city)} short sales`;
      } else if (data.state) {
        title = `${capitalize(data.stateName)} Short Sale Homes | Auction Opportunities | Hubzu`;
        metaTags = `Browse short sale homes in ${capitalize(data.stateName)}. View details and participate in online auctions.`;
        metaKeyWords = `${capitalize(data.stateName)} short sale homes, short sale homes in ${capitalize(data.stateName)}, ${data.state.toUpperCase()} short sales`;
      } else {
        title = 'Short Sale Homes | Browse Auction Opportunities | Hubzu';
        metaTags = 'Explore short sale homes available through auction. Review property details and participate in bidding.';
        metaKeyWords = 'short sale homes, short sale properties, distressed home sales';
      }
    } else if (specialLandingUrlSuffix.includes('/auctions/condos')) {
      if (data.city) {
        title = `${capitalize(data.city)} Condos for Auction | Browse Properties | Hubzu`;
        metaTags = `Explore condo auctions in ${capitalize(data.city)}. Review details and participate in bidding.`;
        metaKeyWords = `${capitalize(data.city)} condos for auction, condo auctions ${capitalize(data.city)}, ${capitalize(data.city)} condo auctions`;
      } else if (data.state) {
        title = `${capitalize(data.stateName)} Condos for Auction | Browse Properties | Hubzu`;
        metaTags = `Browse condos available through auction in ${capitalize(data.stateName)}. View details and participate in bidding.`;
        metaKeyWords = `${capitalize(data.stateName)} condos for auction, condo auctions ${capitalize(data.stateName)}, ${data.state.toUpperCase()} condo auctions`;
      } else {
        title = 'Condos for Auction | Browse Available Properties | Hubzu';
        metaTags = 'Explore condos available through auction. Review property details and participate in online bidding.';
        metaKeyWords = 'condos for auction, condo auctions, condominium auctions';
      }
    } else if (specialLandingUrlSuffix.includes('/auctions/land')) {
      if (data.city) {
        title = `${capitalize(data.city)} Land for Auction | Browse Properties | Hubzu`;
        metaTags = `Explore land auctions in ${capitalize(data.city)}. Review details and participate in bidding.`;
        metaKeyWords = `${capitalize(data.city)} land for auction, land auctions ${capitalize(data.city)}, ${capitalize(data.city)} land auctions`;
      } else if (data.state) {
        title = `${capitalize(data.stateName)} Land for Auction | Browse Properties | Hubzu`;
        metaTags = `Browse land available through auction in ${capitalize(data.stateName)}. View details and participate in bidding.`;
        metaKeyWords = `${capitalize(data.stateName)} land for auction, land auctions ${capitalize(data.stateName)}, ${data.state.toUpperCase()} land auctions`;
      } else {
        title = 'Land for Auction | Browse Available Properties | Hubzu';
        metaTags = 'Explore land available through auction. Review property details and participate in bidding.';
        metaKeyWords = 'land for auction, land auctions, lots for auction';
      }
    } else if (specialLandingUrlSuffix.includes('/bank-owned')) {
      if (data.city) {
        title = `${capitalize(data.city)} Bank-Owned Homes | REO Auctions | Hubzu`;
        metaTags = `Explore bank-owned homes in ${capitalize(data.city)}. Review details and participate in bidding.`;
        metaKeyWords = `${capitalize(data.city)} bank owned homes, REO homes ${capitalize(data.city)}, ${capitalize(data.city)} bank owned properties`;
      } else if (data.state) {
        title = `${capitalize(data.stateName)} Bank-Owned Homes | REO Auctions | Hubzu`;
        metaTags = `Browse bank-owned homes in ${capitalize(data.stateName)}. View details and participate in auctions.`;
        metaKeyWords = `${capitalize(data.stateName)} bank owned homes, REO homes ${capitalize(data.stateName)}, ${data.state.toUpperCase()} bank owned properties`;
      } else {
        title = 'Bank-Owned Homes | REO Auction Opportunities | Hubzu';
        metaTags = 'Explore bank-owned homes available through auction. Review details and participate in bidding.';
        metaKeyWords = 'bank owned homes, REO properties, bank owned properties';
      }
    } else if (specialLandingUrlSuffix.includes('/non-bank-owned')) {
      if (data.city) {
        title = `${capitalize(data.city)} Non-Bank-Owned Homes | Auction Opportunities | Hubzu`;
        metaTags = `Explore non-bank-owned homes in ${capitalize(data.city)}. Review details and participate in bidding.`;
        metaKeyWords = `${capitalize(data.city)} non bank owned homes, traditional homes ${capitalize(data.city)}, ${capitalize(data.city)} non bank owned homes`;
      } else if (data.state) {
        title = `${capitalize(data.stateName)} Non-Bank-Owned Homes | Auction Opportunities | Hubzu`;
        metaTags = `Browse non-bank-owned homes in ${capitalize(data.stateName)}. View details and participate in auctions.`;
        metaKeyWords = `${capitalize(data.stateName)} non bank owned homes, traditional homes ${capitalize(data.stateName)}, ${data.state.toUpperCase()} non bank owned homes`;
      } else {
        title = 'Non-Bank-Owned Homes | Auction Opportunities | Hubzu';
        metaTags = 'Explore non-bank-owned homes available through auction. Review property details and participate in bidding.';
        metaKeyWords = 'non bank owned homes, traditional sale homes, non REO properties';
      }
    } else if (specialLandingUrlSuffix.includes('/traditional-sale')) {
      title = 'Traditional Homes for Sale | Explore Opportunities | Hubzu';
      metaTags = 'Browse traditional homes for sale and explore available opportunities on Hubzu.';
      metaKeyWords = 'traditional homes for sale, non auction homes, standard home sales';
    }
  }
  return {
    title,
    metaTags,
    metaKeyWords,
  };
}
export const generatePDPMeta = ({pdpInitData, pathname}) => {
  const category = `${pathname?.includes('/') && pathname?.split('/')[1]}`;
  let title = '';
  let description = '';
  let metaKeyWords = '';

  if (category === 'REO' || category === 'bank-owned-home') {
    title = 'Bank-Owned Home';
    description = 'View details for this bank-owned home';
  } else if (category === 'SHRT_SALE' || category === 'short-sale-home') {
    title = 'Short Sale Home';
    description = 'View details for this short sale home';
  } else if (category === 'NON_REO' || category === 'non-bank-owned-home') {
    title = 'Non Bank-Owned Home';
    description = 'View details for this non bank-owned home';
  } else if (category === 'FORECLOSURE' || category === 'foreclosure-home') {
    title = 'Foreclosure Home';
    description = 'View details for this foreclosure home';
  } else if (category === 'SC' || category === 'second-chance-home') {
    title = 'Second Chance Home';
    description = 'View details for this second chance home';
  } else if (category === 'ABS' || category === 'absolute-auction-home') {
    title = 'Absolute Auction Home';
    description = 'View details for this absolute auction home';
  } else if (category === 'NPL'|| category === 'non-performing-loan') {
    title = 'Non Performing Loan Home';
    description = 'View details for this non performing loan home';
  } else if (category === 'COMMERCIAL' || category === 'commercial-building') {
    title = 'Commercial Property';
    description = 'Explore this commercial property';
  }

  if (pdpInitData?.address?.city && pdpInitData?.address?.state) {
    title = title + ` | ${pdpInitData?.address?.streetNumber?.trim()} ${pdpInitData?.address?.streetName?.trim()}, ${pdpInitData?.address?.city}, ${pdpInitData?.address?.state} ${pdpInitData?.address?.zip}`;
    description = description + ` in ${pdpInitData?.address?.city}, ${pdpInitData?.address?.state}`;
    if (category === 'REO' || category === 'bank-owned-home') {
      metaKeyWords = `bank owned home ${pdpInitData?.address?.city} ${pdpInitData?.address?.state}, REO home ${pdpInitData?.address?.city}, bank owned property ${pdpInitData?.address?.city}`;
    } else if (category === 'SHRT_SALE' || category === 'short-sale-home') {
      metaKeyWords = `short sale home ${pdpInitData?.address?.city} ${pdpInitData?.address?.state}, short sale property ${pdpInitData?.address?.city}`;
    } else if (category === 'NON_REO' || category === 'non-bank-owned-home') {
      metaKeyWords = `non bank owned home ${pdpInitData?.address?.city} ${pdpInitData?.address?.state}, non bank owned property ${pdpInitData?.address?.city}`;
    } else if (category === 'FORECLOSURE' || category === 'foreclosure-home') {
      metaKeyWords = `foreclosure home ${pdpInitData?.address?.city} ${pdpInitData?.address?.state}, foreclosure property ${pdpInitData?.address?.city}`;
    } else if (category === 'SC' || category === 'second-chance-home') {
      metaKeyWords = `second chance home ${pdpInitData?.address?.city} ${pdpInitData?.address?.state}, second chance property ${pdpInitData?.address?.city}`;
    } else if (category === 'ABS' || category === 'absolute-auction-home') {
      metaKeyWords = `absolute auction home ${pdpInitData?.address?.city} ${pdpInitData?.address?.state}, absolute auction property ${pdpInitData?.address?.city}`;
    } else if (category === 'NPL'|| category === 'non-performing-loan') {
      metaKeyWords = `non performing loan home ${pdpInitData?.address?.city} ${pdpInitData?.address?.state}, non performing loan property ${pdpInitData?.address?.city}`;
    } else if (category === 'COMMERCIAL' || category === 'commercial-building') {
      metaKeyWords = `commercial property ${pdpInitData?.address?.city} ${pdpInitData?.address?.state}, commercial building ${pdpInitData?.address?.city}, commercial real estate ${pdpInitData?.address?.city}`;
    }
  }
  if (category === 'COMMERCIAL' || category === 'commercial-building') {
    title = title + ' | Building Details | Hubzu';
  description = `${description}. Review property details and auction information on Hubzu.`;
  } else {
    title = title + ' | Property Details | Hubzu';
  description = `${description}. Explore photos and property information on Hubzu.`;
  }
  return {title, description, metaKeyWords};
}
